"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _react = require("react"),
    _globalCursor = _interopRequireDefault(require("./utils/globalCursor"));

function _createSuper(Derived) {
  return function () {
    var result,
        Super = (0, _getPrototypeOf2["default"])(Derived);

    if (_isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else result = Super.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}

var DragHandler = function (_Component) {
  function DragHandler() {
    var _this;

    return (0, _classCallCheck2["default"])(this, DragHandler), _this = _super.call(this), _this.onDrag = function (e) {
      var button = e.button;

      if (2 !== button) {
        e.preventDefault(), e.stopPropagation();
        var onDrag = _this.props.onDrag,
            dragTarget = _this.state.dragTarget,
            xPos = e.clientX,
            yPos = e.clientY;
        onDrag({
          x: 0 <= xPos ? xPos : 0,
          y: 0 <= yPos ? yPos : 0,
          dragTarget: dragTarget
        });
      }
    }, _this.startDrag = function (e) {
      var dragContainerSelector = _this.props.dragContainerSelector,
          dragContent = document.querySelector(dragContainerSelector || "body");

      if (dragContent) {
        var cursor = _this.props.cursor;
        cursor && _globalCursor["default"].set(cursor), _this.setState({
          isDragging: !0,
          dragTarget: e.target
        }, function () {
          document.addEventListener("mousemove", _this.onDrag), document.addEventListener("mouseup", _this.stopDrag);
        });
      }
    }, _this.stopDrag = function (e) {
      _this.onDrag(e);

      var cursor = _this.props.cursor;
      cursor && _globalCursor["default"].reset(), _this.setState({
        isDragging: !1,
        dragTarget: void 0
      }, function () {
        document.removeEventListener("mousemove", _this.onDrag), document.removeEventListener("mouseup", _this.stopDrag);
      });
    }, _this.state = {
      isDragging: !1,
      dragTarget: void 0
    }, _this;
  }

  (0, _inherits2["default"])(DragHandler, _Component);

  var _super = _createSuper(DragHandler);

  return (0, _createClass2["default"])(DragHandler, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onDrag = _this$props.onDrag,
          children = _this$props.children,
          isDragging = this.state.isDragging;
      return children({
        onMouseDown: onDrag ? this.startDrag : void 0,
        isDragging: isDragging
      });
    }
  }]), DragHandler;
}(_react.Component);

exports["default"] = DragHandler;